import { ProviderTemplate } from './types';

export const cloudProviders: Record<string, ProviderTemplate> = {
  aws_route53: {
    name: 'AWS Route53',
    icon: '🟠',
    description: 'Amazon Web Services DNS',
    fields: [
      {
        key: 'aws_access_key_id',
        label: 'Access Key ID',
        type: 'text',
        required: true,
        help: 'AWS Access Key ID with Route53 permissions',
      },
      {
        key: 'aws_secret_access_key',
        label: 'Secret Access Key',
        type: 'password',
        required: true,
        help: 'AWS Secret Access Key',
      },
      {
        key: 'region',
        label: 'Region',
        type: 'select',
        required: true,
        options: [
          'us-east-1',
          'us-west-2',
          'eu-west-1',
          'ap-southeast-1',
          'ap-northeast-1',
          'ca-central-1',
        ],
        help: 'AWS region for Route53 API calls',
      },
      {
        key: 'session_token',
        label: 'Session Token (Optional)',
        type: 'password',
        required: false,
        help: 'Temporary session token if using STS',
      },
    ],
    docsUrl: 'https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/auth-and-access-control.html',
  },
  azure_dns: {
    name: 'Azure DNS',
    icon: '🔵',
    description: 'Microsoft Azure DNS',
    fields: [
      {
        key: 'client_id',
        label: 'Client ID',
        type: 'text',
        required: true,
        help: 'Azure Application (Client) ID',
      },
      {
        key: 'client_secret',
        label: 'Client Secret',
        type: 'password',
        required: true,
        help: 'Azure Application Secret',
      },
      {
        key: 'tenant_id',
        label: 'Tenant ID',
        type: 'text',
        required: true,
        help: 'Azure Directory (Tenant) ID',
      },
      {
        key: 'subscription_id',
        label: 'Subscription ID',
        type: 'text',
        required: true,
        help: 'Azure Subscription ID',
      },
      {
        key: 'resource_group',
        label: 'Resource Group',
        type: 'text',
        required: true,
        help: 'Resource group containing DNS zones',
      },
    ],
    docsUrl: 'https://docs.microsoft.com/en-us/azure/dns/dns-sdk',
  },
  gcp_cloud_dns: {
    name: 'Google Cloud DNS',
    icon: '🟢',
    description: 'Google Cloud Platform DNS',
    fields: [
      {
        key: 'project_id',
        label: 'Project ID',
        type: 'text',
        required: true,
        help: 'Google Cloud Project ID',
      },
      {
        key: 'service_account_key',
        label: 'Service Account Key',
        type: 'textarea',
        required: true,
        help: 'JSON service account key with Cloud DNS permissions',
      },
      {
        key: 'zone_visibility',
        label: 'Zone Visibility',
        type: 'select',
        required: false,
        options: ['public', 'private', 'both'],
        help: 'Types of zones to manage (default: public)',
      },
    ],
    docsUrl: 'https://cloud.google.com/dns/docs/reference/libraries',
  },
};